import { ace } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send';

export const getAgentAssignmentsV3 =
  ({ token, url: { service: baseURL } }: IAPI) =>
  ({
    AgentID,
  }: ace.GetAgentAssignmentReq): Promise<ace.GetAgentAssignmentRes> =>
    send({
      baseURL,
      token,
      path: `ace/assignments/v3/agents/${encodeURIComponent(AgentID)}`,
      method: 'GET',
    });

export const postAgentAssignmentsV3 =
  ({ token, url: { service: baseURL } }: IAPI) =>
  async ({
    Count = 1,
  }: ace.PostAgentAssignmentReq): Promise<ace.PostAgentAssignmentRes> =>
    send({
      baseURL,
      token,
      path: 'ace/assignments/v3/next-assignment',
      method: 'POST',
      body: {
        Count,
      },
    });

export const findAgents =
  ({ token, url: { service: baseURL } }: IAPI) =>
  (req: ace.FindAgentsReq): Promise<ace.FindAgentsRes> =>
    send({
      baseURL,
      token,
      path: 'ace/assignments/v3/agents',
      method: 'GET',
      searchParams: req,
    });

export const patchApplicationAssignment =
  ({ token, url: { service: baseURL } }: IAPI) =>
  async (
    applicationId: string,
    payload: ace.PatchApplicationAssignmentReq,
  ): Promise<ace.GetAssignmentApplicationRes> =>
    send({
      baseURL,
      token,
      path: `ace/assignments/v3/applications/${encodeURIComponent(
        applicationId
      )}`,
      method: 'PATCH',
      body: payload,
    });

export const setAgentAvailableV3 =
  ({ token, url: { service: baseURL } }: IAPI) =>
  ({ AgentID }: ace.SetAgentAvailableReq): Promise<ace.SetAgentAvailableRes> =>
    send({
      baseURL,
      token,
      path: `ace/assignments/v3/agents/${encodeURIComponent(
        AgentID
      )}/available`,
      method: 'PUT',
    });

export const setAgentUnavailableV3 =
  ({ token, url: { service: baseURL } }: IAPI) =>
  ({
    AgentID,
  }: ace.SetAgentUnavailableReq): Promise<ace.SetAgentUnavailableRes> =>
    send({
      baseURL,
      token,
      path: `ace/assignments/v3/agents/${encodeURIComponent(
        AgentID
      )}/available`,
      method: 'DELETE',
    });

export const getAssignmentApplicationV3 =
  ({ token, url: { service: baseURL } }: IAPI) =>
  ({
    ApplicationID,
  }: ace.GetAssignmentApplicationReq): Promise<ace.GetAssignmentApplicationRes> =>
    send({
      baseURL,
      token,
      path: `ace/assignments/v3/applications/${encodeURIComponent(
        ApplicationID
      )}`,
      method: 'GET',
    });

export const setApplicationProcessedV3 =
  ({ token, url: { service: baseURL } }: IAPI) =>
  ({
    ApplicationID,
  }: ace.SetApplicationProcessedReq): Promise<ace.SetApplicationProcessedRes> =>
    send({
      baseURL,
      token,
      path: `ace/assignments/v3/applications/${encodeURIComponent(
        ApplicationID
      )}/processed`,
      method: 'PUT',
    });

export const getAgentAssignmentsListV3 =
  ({ token, url: { service: baseURL } }: IAPI) =>
  ({
    AgentID,
  }: ace.GetAgentAssignmentsListV3Req): Promise<ace.GetAgentAssignmentsListV3Res> =>
    send({
      baseURL,
      token,
      path: `ace/assignments/v3/agents/${encodeURIComponent(
        AgentID
      )}/assignments`,
      method: 'GET',
    });
